import { render, staticRenderFns } from "./ProjectOne.vue?vue&type=template&id=56915f2b"
import script from "./ProjectOne.vue?vue&type=script&lang=js"
export * from "./ProjectOne.vue?vue&type=script&lang=js"
import style0 from "./ProjectOne.vue?vue&type=style&index=0&id=56915f2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports